// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"chainlist_wrapper__hkqBv","chainBlockParent":"chainlist_chainBlockParent__Rcvg5","chainBlock":"chainlist_chainBlock__9yjUE"};